var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInverted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 52,
    viewBox: "0 0 188 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.393 0.359895C37.299 1.00445 44.9575 1.13764 49.476 6.39991C54.1781 11.876 53.9834 19.7244 53.1795 26.8973C52.3407 34.3814 50.8281 42.3248 44.9255 47.0019C38.9054 51.7721 30.46 52.8731 23.0788 50.7485C16.433 48.8355 13.0317 42.2346 8.95529 36.6482C4.95092 31.1605 -0.564836 25.9506 0.0467848 19.1848C0.677054 12.2128 6.05704 6.59302 12.0059 2.90273C17.4718 -0.487974 23.9886 -0.237837 30.393 0.359895Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9636 15.5273L27.9258 15.6482H28.0007L27.9636 15.5273Z",
    fill: "url(#paint0_linear_20_482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8704 19.0453L25.4315 19.0453L26.4864 15.6482H24.5562L23.5007 19.0453H19.466L18.4106 15.6482H16.4798L17.5347 19.0453H16.0958L15.0404 15.6482H13.1096L14.165 19.0453H10.448V20.9504H14.7568L14.7578 20.9541H16.6886L16.6875 20.9504H18.1264L18.1275 20.9541H20.0588L20.0577 20.9504H22.909L22.908 20.9541H24.8387L24.8398 20.9504H26.2787L26.2777 20.9541H29.6489L29.6479 20.9504H31.0868L31.0878 20.9541H33.0192L33.0181 20.9504H35.8694L35.8683 20.9541H37.7991L37.8001 20.9504H39.2391L39.238 20.9541H41.1693L41.1704 20.9504L45.6252 20.9504V19.0453H41.7621L42.8175 15.6482H40.8862L39.8308 19.0453H38.3919L39.4468 15.6482H37.5165L36.4611 19.0453H32.4264L31.371 15.6482H29.4402L30.4951 19.0453L29.0562 19.0453L28.0007 15.6482H27.9258L26.8704 19.0453Z",
    fill: "url(#paint1_linear_20_482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 26.7865H16.5691L16.568 26.7828H10.448V24.8777H15.9763L15.0537 21.9069H16.9844L17.9071 24.8777H19.346L18.4234 21.9069H20.3547L21.2773 24.8777L21.6895 24.8777L22.6121 21.9069H24.5429L23.6203 24.8777H25.0592L25.9818 21.9069H27.9131L26.9905 24.8777H28.9367L28.014 21.9069H29.9448L30.8674 24.8777H32.3063L31.3837 21.9069H33.315L34.2376 24.8777H34.6498L35.5725 21.9069H37.5032L36.5806 24.8777H38.0195L38.9422 21.9069H40.8735L39.9508 24.8777H45.6252V26.7828L39.3591 26.7828L39.3581 26.7865H37.4268L37.4278 26.7828H35.9889L35.9873 26.7865H32.8997L32.8981 26.7828H31.4591L31.4602 26.7865H29.5294L29.5284 26.7828H26.3988L26.3977 26.7865H24.4664L24.4674 26.7828H23.0285L23.027 26.7865H19.9393L19.9377 26.7828H18.4988L18.4999 26.7865Z",
    fill: "url(#paint2_linear_20_482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.014 21.9069H27.9131L27.9636 21.7447L28.014 21.9069Z",
    fill: "url(#paint3_linear_20_482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1018 27.7393H24.1705L22.4241 33.3612H20.5422L18.7957 27.7393H16.8649L19.2031 35.2663H23.7637L26.1018 27.7393Z",
    fill: "url(#paint4_linear_20_482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7311 27.7393L21.4834 31.7578L20.2351 27.7393H22.7311Z",
    fill: "url(#paint5_linear_20_482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0622 27.7393H37.1309L35.3844 33.3612H33.5025L31.7561 27.7393H29.8253L32.1635 35.2663H36.724L39.0622 27.7393Z",
    fill: "url(#paint6_linear_20_482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6915 27.7393L34.4438 31.7578L33.1955 27.7393H35.6915Z",
    fill: "url(#paint7_linear_20_482)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.524 46.3548H156.386C157.47 46.3548 158.155 45.8127 158.155 44.9782C158.155 44.3576 157.884 43.9154 157.071 43.7228C157.684 43.4945 157.877 43.1521 157.877 42.6742C157.877 41.8967 157.292 41.3618 156.208 41.3618H154.524V46.3548ZM155.523 45.4561V44.2364H156.293C156.835 44.2364 157.142 44.4575 157.142 44.8213C157.142 45.2564 156.835 45.4561 156.293 45.4561H155.523ZM155.523 43.4232V42.2534H156.115C156.657 42.2534 156.864 42.4888 156.864 42.8312C156.864 43.2306 156.657 43.4232 156.115 43.4232H155.523Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.927 47.8456C159.797 47.8456 160.261 47.3392 160.575 46.5902L162.215 42.6457H161.074L160.354 44.7642C160.289 44.9425 160.232 45.1636 160.197 45.3562C160.161 45.1636 160.104 44.9425 160.04 44.7642L159.319 42.6457H158.157L159.626 46.1837L159.576 46.3406C159.469 46.6687 159.234 46.9041 158.863 46.9041C158.706 46.9041 158.57 46.8898 158.428 46.8542L158.285 47.7743C158.478 47.8314 158.734 47.8456 158.927 47.8456Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.887 46.4476C166.757 46.4476 167.399 46.1123 167.777 45.6558L167.049 45.0353C166.757 45.3562 166.393 45.5203 165.908 45.5203C164.924 45.5203 164.317 44.7785 164.317 43.8654C164.317 42.9524 164.924 42.1963 165.887 42.1963C166.336 42.1963 166.707 42.3533 167.007 42.6671L167.713 42.0537C167.263 41.5187 166.7 41.269 165.887 41.269C164.346 41.269 163.283 42.4317 163.283 43.8654C163.283 45.292 164.403 46.4476 165.887 46.4476Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.594 46.4476C170.258 46.4476 170.593 46.1694 170.793 45.7485V46.3548H171.727V42.6457H170.771V43.2306C170.572 42.8312 170.236 42.5672 169.594 42.5672C168.574 42.5672 167.761 43.4446 167.761 44.5145C167.761 45.5845 168.574 46.4476 169.594 46.4476ZM168.724 44.5074C168.724 43.9296 169.138 43.4375 169.751 43.4375C170.386 43.4375 170.793 43.9368 170.793 44.5145C170.793 45.0923 170.386 45.5774 169.751 45.5774C169.138 45.5774 168.724 45.0709 168.724 44.5074Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M172.299 46.3548H173.262V44.4575C173.262 43.8369 173.69 43.466 174.247 43.466H174.382V42.5601C173.74 42.5244 173.362 42.8169 173.234 43.3519V42.6457H172.299V46.3548Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.942 46.3548H176.912L178.452 42.6457H177.333L176.591 44.7642C176.527 44.9425 176.47 45.1636 176.434 45.3562C176.398 45.1636 176.341 44.9425 176.277 44.7642L175.535 42.6457H174.394L175.942 46.3548Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.631 46.3548H179.594V42.6457H178.631V46.3548ZM178.531 41.7684C178.531 42.0822 178.781 42.339 179.109 42.339C179.444 42.339 179.687 42.0893 179.687 41.7684C179.687 41.4616 179.444 41.2048 179.109 41.2048C178.781 41.2048 178.531 41.4616 178.531 41.7684Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M181.319 46.3548H182.289L183.83 42.6457H182.71L181.968 44.7642C181.904 44.9425 181.847 45.1636 181.811 45.3562C181.776 45.1636 181.719 44.9425 181.655 44.7642L180.913 42.6457H179.771L181.319 46.3548Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M185.463 46.4476C186.126 46.4476 186.461 46.1694 186.661 45.7485V46.3548H187.595V42.6457H186.639V43.2306C186.44 42.8312 186.104 42.5672 185.463 42.5672C184.443 42.5672 183.629 43.4446 183.629 44.5145C183.629 45.5845 184.443 46.4476 185.463 46.4476ZM184.592 44.5074C184.592 43.9296 185.006 43.4375 185.619 43.4375C186.254 43.4375 186.661 43.9368 186.661 44.5145C186.661 45.0923 186.254 45.5774 185.619 45.5774C185.006 45.5774 184.592 45.0709 184.592 44.5074Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.417 33.7101H67.0029V26.3845H73.8162V23.2084H67.0029V19.0077H73.9443V15.7804H63.417V33.7101Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8112 34.0174C82.8859 34.0174 84.0897 33.249 84.7301 31.7122V33.7101H88.0855V20.3909H84.6276V27.6908C84.6276 29.996 83.3213 30.995 81.8613 30.995C80.1452 30.995 79.1975 29.996 79.1975 27.6908V20.3909H75.7396V28.5361C75.7396 31.8915 77.9424 34.0174 80.8112 34.0174Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5032 34.043C99.1415 34.043 101.37 32.8648 102.446 31.1999L99.7562 29.1764C99.1415 30.201 97.9888 30.9694 96.5032 30.9694C94.7615 30.9694 93.5833 29.868 93.1991 28.3055H103.163C103.24 27.8701 103.265 27.4603 103.265 27.0761C103.265 23.234 100.499 20.0579 96.5032 20.0579C92.5075 20.0579 89.6131 23.234 89.6131 27.0761C89.6131 30.9181 92.3794 34.043 96.5032 34.043ZM93.1991 25.7185C93.5833 24.1305 94.8127 23.0291 96.452 23.0291C98.1425 23.0291 99.3976 24.2329 99.7818 25.7185H93.1991Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.783 33.7101H108.241V15.012H104.783V33.7101Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M118.977 33.7101H122.204L125.841 23.5926C126.174 22.6449 126.431 21.6203 126.584 20.647C126.738 21.6203 126.994 22.6449 127.327 23.5926L130.964 33.7101H134.192L140.185 15.7804H136.087L133.218 25.9234C132.936 26.948 132.68 27.9982 132.552 28.9971C132.399 27.9982 132.117 26.9224 131.758 25.9234L128.198 15.7804H124.971L121.41 25.9234C121.052 26.9224 120.796 27.9982 120.667 28.9971C120.514 27.9982 120.232 26.948 119.95 25.9234L117.082 15.7804H112.983L118.977 33.7101Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M145.422 34.043C147.805 34.043 149.008 33.0441 149.726 31.5329V33.7101H153.081V20.3909H149.649V22.4912C148.932 21.0568 147.728 20.1091 145.422 20.1091C141.76 20.1091 138.84 23.2596 138.84 27.1017C138.84 30.9438 141.76 34.043 145.422 34.043ZM142.298 27.0761C142.298 25.0014 143.783 23.234 145.986 23.234C148.266 23.234 149.726 25.027 149.726 27.1017C149.726 29.1764 148.266 30.9181 145.986 30.9181C143.783 30.9181 142.298 29.0996 142.298 27.0761Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M155.135 33.7101H158.593V15.012H155.135V33.7101Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M160.638 33.7101H164.096V15.012H160.638V33.7101Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M172.519 34.043C175.157 34.043 177.386 32.8648 178.462 31.1999L175.772 29.1764C175.157 30.201 174.005 30.9694 172.519 30.9694C170.778 30.9694 169.599 29.868 169.215 28.3055H179.179C179.256 27.8701 179.281 27.4603 179.281 27.0761C179.281 23.234 176.515 20.0579 172.519 20.0579C168.523 20.0579 165.629 23.234 165.629 27.0761C165.629 30.9181 168.395 34.043 172.519 34.043ZM169.215 25.7185C169.599 24.1305 170.829 23.0291 172.468 23.0291C174.159 23.0291 175.414 24.2329 175.798 25.7185H169.215Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M185.345 33.7101H187.24V30.6364H185.806C185.14 30.6364 184.73 30.2522 184.73 29.4069V23.3365H187.548V20.3909H184.73V17.3428L181.272 17.7014V20.3909H179.403V23.3365H181.272V29.5862C181.272 32.4806 182.707 33.7101 185.345 33.7101Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_482",
    x1: 18.7427,
    y1: 20.173,
    x2: 23.8151,
    y2: 31.0905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89E0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CC393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_482",
    x1: 18.7427,
    y1: 20.173,
    x2: 23.8151,
    y2: 31.0905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89E0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CC393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20_482",
    x1: 18.7427,
    y1: 20.173,
    x2: 23.8151,
    y2: 31.0905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89E0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CC393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20_482",
    x1: 18.7427,
    y1: 20.173,
    x2: 23.8151,
    y2: 31.0905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89E0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CC393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20_482",
    x1: 18.7427,
    y1: 20.173,
    x2: 23.8151,
    y2: 31.0905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89E0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CC393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_20_482",
    x1: 18.7427,
    y1: 20.173,
    x2: 23.8151,
    y2: 31.0905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89E0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CC393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_20_482",
    x1: 18.7427,
    y1: 20.173,
    x2: 23.8151,
    y2: 31.0905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89E0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CC393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_20_482",
    x1: 18.7427,
    y1: 20.173,
    x2: 23.8151,
    y2: 31.0905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89E0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CC393"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.1773,
    height: 19.739,
    fill: "white",
    transform: "translate(10.4481 15.5273)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInverted);
export default __webpack_public_path__ + "static/media/inverted.60b64d5f68fe0636c3c6d41ff955211b.svg";
export { ForwardRef as ReactComponent };